import * as actionTypes from '../actions/actionType';

export const countryReducer = (state = [], action = {}) => {
  switch (action.type) {
    case actionTypes.LOAD_ALL_COUNTRY:
      return action.data;
    default:
      return state;
  }
};

export default countryReducer;
